import { createSelector } from '@reduxjs/toolkit'
import { makeSelectCartEvaluationRequiresTripRequestForm } from './makeSelectCartEvaluationRequiresTripRequestForm'

/** Whether the unified trip request form should show: any evaluated cart item plus a required approval. */
export const selectShouldShowUnifiedTripRequestForm = createSelector(
  makeSelectCartEvaluationRequiresTripRequestForm(),
  (decision): boolean => decision ?? false,
)
